export const getMonthDifference = (d1: Date, d2: Date) => {
  const yearsDifference = d2.getUTCFullYear() - d1.getUTCFullYear()
  const monthsDifference = d2.getUTCMonth() - d1.getUTCMonth()
  const daysDifference = d2.getUTCDate() - d1.getUTCDate()

  let monthCorrection = 0
  // If the day difference between the 2 months is negative, the last month is not a whole month.
  if (daysDifference > 0) {
    monthCorrection = 1
  }
  // If the day difference between the 2 months is negative, the last month is not a whole month.
  else if (daysDifference < 0) {
    monthCorrection = -1
  }

  return yearsDifference * 12 + monthsDifference + monthCorrection
}
